// The agent lineup behind the /ai/agents dashboard cards. Store-bound agents
// (scope 'store') work one store's orders and get a card per store;
// merchant-wide agents (scope 'merchant') pick customers across every store
// and get one card in the Global section.
export const NEW_AGENT_PATH = '/ai/agents/new'

// The setup page for an agent type, pinned to a store when the card is a
// store's card.
export const newAgentPath = (slug, storeId) =>
  storeId ? `${NEW_AGENT_PATH}/${slug}?store_id=${storeId}` : `${NEW_AGENT_PATH}/${slug}`

export const AGENT_CARDS = [
  {
    key: 'upsell',
    title: 'Upsell Agent',
    category: 'Sales',
    iconKey: 'trending-up',
    description: 'Suggests the right add-ons at checkout and over SMS to lift average order value automatically.',
    emptyHint: 'Live - waiting for the first upsell.',
    available: true,
    route: newAgentPath('upsell'),
    agentType: 'UpsellAgent',
    scope: 'store'
  },
  {
    key: 'winback',
    title: 'Winback Agent',
    category: 'Retention',
    iconKey: 'clock',
    description: 'Spots customers who are slipping away and sends a timely, personalized message to bring them back.',
    emptyHint: 'Live - waiting for the first win-back.',
    available: true,
    route: newAgentPath('winback'),
    agentType: 'WinbackAgent',
    scope: 'merchant'
  },
  {
    key: 'abandon-cart',
    title: 'Abandon Cart Agent',
    category: 'Recovery',
    iconKey: 'cart',
    description: 'Follows up with shoppers who left items behind and nudges them to finish checking out.',
    emptyHint: 'Live - waiting for the first abandoned cart.',
    available: true,
    route: newAgentPath('abandon-cart'),
    agentType: 'AbandonCartAgent',
    scope: 'store'
  },
  {
    key: 'reviews',
    title: 'Reviews Agent',
    category: 'Reputation',
    iconKey: 'star',
    description: 'Asks happy customers for a Google Business review at the perfect moment to grow your rating.',
    emptyHint: 'Live - waiting for the first review request.',
    available: true,
    route: newAgentPath('reviews'),
    agentType: 'ReviewAgent',
    scope: 'merchant'
  }
]

export const STORE_AGENT_CARDS = AGENT_CARDS.filter(card => card.scope === 'store')

export const MERCHANT_AGENT_CARDS = AGENT_CARDS.filter(card => card.scope === 'merchant')

export const isMerchantWideType = type => MERCHANT_AGENT_CARDS.some(card => card.agentType === type)

export const agentTypeForSlug = slug => AGENT_CARDS.find(card => card.key === slug)?.agentType

export const slugForAgentType = type => AGENT_CARDS.find(card => card.agentType === type)?.key

export const agentTitleForType = type => AGENT_CARDS.find(card => card.agentType === type)?.title
